import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { PopoverAnchorProps } from "reka-ui"
import { PopoverAnchor } from "reka-ui"


export default /*@__PURE__*/_defineComponent({
  __name: 'PopoverAnchor',
  props: {
    reference: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PopoverAnchor), _mergeProps({ "data-slot": "popover-anchor" }, props), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})